import React, { memo, useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchPrintingSingleOutwardInfo, fetchPrintInwardNo, insertPrintInward } from '../../Store/PHPSlice/Printing';


const PrintingInward = () => {

    const { Id } = useParams();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();

    // LOCAL STATE
    const [formData, setFormData] = useState({
        prId: Id,
        dt: getCurrentDate(),
        empNm: '',
        empId: '',
        soId: '',
        sono: '',
        itemId: '',
        itemNm: '',
        firmId: '',
        firmNm: '',
        memo: '',
        userId: userdata?.ID
    });

    const [inwardData, setInwardData] = useState([]);
    const [loading, setLoading] = useState(false);

    // SELECT SINGLE API DATA
    const singleData = useSelector(state => state.PrintingData.singlePrintoutData);
    // CALL API
    useEffect(() => {
        dispatch(fetchPrintingSingleOutwardInfo(Id));
        dispatch(fetchPrintInwardNo());
    }, [Id, dispatch]);

    // MAP API DATA TO FORM & TABLE
    // ✅ Fetch printout number from Redux slice
    const printoutNoState = useSelector((state) => state.PrintingData.printinNo);
    console.log("printoutno=>", printoutNoState)
    // useEffect(() => {
    //     if (singleData) {
    //         setFormData(prev => ({
    //             ...prev,
    //             dt: singleData.dt,
    //             empNm: singleData.empNm,
    //             empId: singleData.empId,
    //             soId: singleData.soId,
    //             sono: singleData.sono,
    //             itemId: singleData.itemId,
    //             itemNm: singleData.itemNm,
    //             firmId: singleData.firmId,
    //             firmNm: singleData.firmNm,
    //             //memo: singleData.memo
    //         }));

    //         // ❗ CHANGE THIS KEY BASED ON API (info / details / data)
    //         setInwardData(singleData.info || []);
    //     }
    // }, [singleData]);

    useEffect(() => {
        if (singleData?.data?.length > 0) {
            const d = singleData.data[0];  // <-- correct record

            setFormData(prev => ({
                ...prev,
                dt: getCurrentDate(),
                printoutNo: d.printoutno,
                delivered_person: d.delivered_person,
                printingmatter: d.printingmatter,
                received_person: d.received_person,
                print_sides: d.print_sides,
                partyId: d.partyId,
                partyNm: d.partyNm,
                itemId: d.itemId,
                itemNm: d.itemNm,

            }));

            setInwardData([
                {
                    size: d.print_sides,
                    totqty: d.balanceqty,
                    balqty: d.balanceqty,
                    inwqty: 0,
                }
            ]);
        }
    }, [singleData]);


    useEffect(() => {
        if (printoutNoState?.data?.length > 0) {
            setFormData(prev => ({
                ...prev,
                printinNo: printoutNoState.data[0].inwardNo
            }));
        }
    }, [printoutNoState]);


    // HANDLE INPUT CHANGES
    const handleDateChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.toUpperCase() });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // ------------------------
        // 1️⃣ VALIDATE DATE
        // ------------------------
        if (!formData.dt || formData.dt.trim() === "") {
            alert("Please select a valid Date.");
            return;
        }

        // ------------------------
        // 2️⃣ VALIDATE INWARD QTY
        // ------------------------
        for (let i = 0; i < inwardData.length; i++) {
            const row = inwardData[i];

            // Empty check
            if (row.inwqty === "" || row.inwqty === null || row.inwqty === undefined) {
                alert(`Please enter Inward Qty for row ${i + 1}`);
                return;
            }

            // Zero or negative
            if (parseFloat(row.inwqty) <= 0) {
                alert(`Inward Qty must be greater than 0 in row ${i + 1}`);
                return;
            }

            // Greater than total
            if (parseFloat(row.inwqty) > parseFloat(row.totqty)) {
                alert(`Inward Qty cannot exceed Total Qty in row ${i + 1}`);
                return;
            }
        }

        // ------------------------
        // 3️⃣ IF VALID → Submit
        // ------------------------
        const payload = {
            ...formData,
            inwardData,
        };

        setLoading(true);

        try {
            const result = await dispatch(insertPrintInward(payload)).unwrap();
            // console.log(result)
            alert("Inward Entry Saved Successfully!");
            window.location.reload();
            window.close();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };


    // HANDLE Qty CHANGE
    // const handleQtyChange = (index, e) => {
    //     const value = parseFloat(e.target.value || 0);
    //     const updated = inwardData?.map((item, i) =>
    //         i === index
    //             ? {
    //                 ...item,
    //                 inwqty: value <= item.totqty ? value : item.totqty,
    //                 bqty: value <= item.totqty ? item.totqty - value : 0
    //             }
    //             : item
    //     );

    //     if (value <= inwardData[index].balqty) {
    //         setInwardData(updated);
    //     } else {
    //         alert("Inward Qty cannot be greater than Remaining Qty.");
    //     }
    // };
    const handleQtyChange = (index, e) => {
        const inwqty = parseFloat(e.target.value || 0);

        setInwardData(prev =>
            prev.map((item, i) => {
                if (i !== index) return item;

                // Remaining qty = Total qty - inward qty
                let remaining = item.totqty - inwqty;

                if (remaining < 0) {
                    alert("Inward Qty cannot be greater than Total Issue Qty.");
                    return item;
                }

                return {
                    ...item,
                    inwqty,
                    balqty: remaining
                };
            })
        );
    };


    const fields = [{ name: 'dt', type: 'date' }];

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Printing Inward Entry</h3>
                        <div className="dashed-line"></div>

                        {/* MAIN FORM INFO */}
                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>
                                    <td style={{ width: '50px' }}>
                                        {fields.map((field) => (
                                            <DateInputComponent
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                            />
                                        ))}
                                    </td>
                                    <td style={{ width: '200px' }}>Inward No.</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>
                                        {formData.printinNo}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Outward No</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.printoutNo}</td>
                                    <td>Item Name</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                </tr>

                                <tr>
                                    <td>Party Name</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.partyNm}</td>
                                    <td>Printing Matter</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.printingmatter}</td>
                                </tr>
                                <tr>
                                    <td>Delivery Person Name</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.delivered_person}</td>
                                    <td>Received Person Name</td>
                                    <td className='light-color' style={{ width: '25vw', padding: '0.2% 1.5%' }}>{formData.received_person}</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* TABLE */}
                        <TableContainer style={{ width: isDesktop ? '90%' : '100%', marginLeft: isDesktop ? '5%' : '0%' }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell align='center'>Sr.No.</TableCell>
                                        <TableCell align='center'>Total Issue Qty.</TableCell>
                                        <TableCell align='center'>Inward Qty</TableCell>

                                        <TableCell align='center'>Remaining Qty.</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {Array.isArray(inwardData) && inwardData.length > 0 ? (
                                        inwardData.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell align='center'>{index + 1}</TableCell>
                                                <TableCell align='center'>{item.totqty}</TableCell>
                                                <TableCell align='center'>
                                                    <input
                                                        type="number"
                                                        value={item.inwqty || ''}
                                                        onChange={(e) => handleQtyChange(index, e)}
                                                        style={{ width: '80px', padding: '1px' }}
                                                    />
                                                </TableCell>
                                                <TableCell align='center'>{item.balqty}</TableCell>

                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">No Data Available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Grid item xs={12} textAlign="center" style={{ marginTop: '2vh' }}>
                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                {
                                    loading === true ?
                                        <><CircularProgress size="20px" /> wait...</> :
                                        "Submit"
                                }
                            </Button>
                        </Grid>

                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default PrintingInward;
